import { VisibilityOff, Visibility } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import moment from 'moment'
import { useState } from 'react'
import { Controller } from 'react-hook-form'

export type ControlledInputPropType = {
    imageUrl?: any, setImageUrl?: any, autoFocus?: boolean, name: string, type?: string, control: any, label?: string, errors: any, discountErrors?: any, size?: any, width?: string, height?: string, disabled?: boolean, setValue?: any, getValues?: any, onBlur?: () => void
}

export const ControlledInput = ({ name, type = 'text', control, label, errors, discountErrors, size = 'small', width, height, disabled = false, autoFocus = false, onBlur }: ControlledInputPropType) => {
    const [showPassword, setShowPassword] = useState(false);
    const [focused, setFocused] = useState(false);

    const handleFocus = () => {
        setFocused(true);
    };

    const handleBlur = () => {
        setFocused(false);
        if (onBlur) {
            onBlur()
        }
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
                <TextField
                    autoFocus={autoFocus}
                    autoComplete='off'
                    size={size ?? 'small'}
                    disabled={disabled}
                    type={type === "password" ? showPassword ? "text" : "password" : type}
                    sx={{ width: width ? width : "100%", }}
                    onChange={(e: any) => { type === "number" ? onChange(Number(e.target.value)) : onChange(e.target.value) }}
                    value={type === 'date' ? moment(value).format('YYYY-MM-DD') : value ?? ''}
                    label={label}
                    variant="outlined"
                    error={discountErrors || (errors[name] && Boolean(errors[name].message))}
                    helperText={errors[name] ? `${errors[name].message}` : discountErrors ?? ""}
                    InputLabelProps={{ shrink: focused || !!value || type === 'date' }}
                    onInput={(e: any) => {
                        if (type === 'number') {
                            const value = parseFloat(e.target.value);
                            if (isNaN(value) || value < 0) {
                                e.target.value = '';
                            }
                        }
                    }}
                    InputProps={{
                        style: { height: height ? height : '' },
                        endAdornment: <>
                            {type === "password" ? PasswordToogle(showPassword, setShowPassword) : ""}
                        </>
                    }}
                    onFocus={(e: any) => {
                        if (type === "number" && e.target.value === '0') {
                            onChange('');
                        }
                        handleFocus();
                    }}
                    onBlur={handleBlur}
                />
            )}
        />
    );
}

const PasswordToogle = (showPassword: boolean, setShowPassword: React.Dispatch<React.SetStateAction<boolean>>) => {
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return <InputAdornment position="end">
        <IconButton
            aria-label="toggle password visibility"
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
        >
            {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
    </InputAdornment>
}
